import Blue from "~/core";

new Blue({
	name: 'Show More List',
	selector: ".showMoreList",
	setup(container) {
    	const initialItemsShown = 6;
		const items = [...container.querySelectorAll(".showMoreList-item")];
		const parent = container.closest("div[class*=col-]");
		const showMoreBtn = parent.querySelector(".showMoreBtn");
		const showLessBtn = parent.querySelector(".showLessBtn");
		// Show first row of items when page loads/widget is added in page viewer 
		items.forEach((item, i) => {
			if (i < initialItemsShown) item.classList.add("visible")
		});
		
		const btnClickHandler = (addClassBool, btnToHide, btnToShow) => {
			let start = container.offsetHeight;
			items.forEach((item, i) => {
				if (i >= initialItemsShown) {
					if (addClassBool) item.classList.add("visible")
					else item.classList.remove("visible")
				}
			});
			let end = container.offsetHeight;
			// FLIP animation animates here
			container.animate([
				{height: `${start}px`},
				{height: `${end}px`}
			], {
				duration: 1000,
				easing: 'ease'
			});
			btnToShow.style.display = "flex";
			btnToHide.style.display = "none";
		}
		// razor view has 'if less than 6 dont show toggle' logic
		// sanity check show more button to prevent additional list items not displaying when less than 6 used
		if (showMoreBtn) {
			this.$addEvents(showMoreBtn, "click", () => {btnClickHandler(true, showMoreBtn, showLessBtn)})
			this.$addEvents(showLessBtn, "click", () => {btnClickHandler(false, showLessBtn, showMoreBtn)})
		}
	}
});